<template>
  <div class="wl-video-detail-wrapper">
    <div class="video-detail-main">
      <div class="clearfix">
        <div class="fl v-detail-con">
          <div class="v-play-con">
            <video-player
              class="video-player-box"
              ref="videoPlayer"
              :options="playerOptions"
              :playsinline="true"
              customEventName="customstatechangedeventname"
              @play="onPlayerPlay($event)"
              @pause="onPlayerPause($event)"
              @canplay="onPlayerCanplay($event)"
              @canplaythrough="onPlayerCanplaythrough($event)"
            ></video-player>
          </div>
          <div class="v-intro-name">{{videoTitle}}</div>
          <div class="clearfix v-download-con">
            <div class="fl">
              <i class="wl-icon-chakan"></i>
              {{viewCount}}次观看
              <i class="wl-icon-dian1"></i>
              <i class="wl-icon-shijian">{{dateCreatedStr}}</i>
            </div>
            <div class="fr clearfix">
              <span class="fl sp-share-label">分享到：</span>
              <a :href="shareLinkQq" class="fl share-icon-con icon-con-1">
                <i class="wl-icon-qq1"></i>
              </a>
              <a :href="shareLinkZone" class="fl share-icon-con icon-con-2">
                <i class="wl-icon-QQkongjian"></i>
              </a>
              <!-- <div class="fl share-icon-con icon-con-3">
                <i class="wl-icon-weixin"></i>
              </div>-->
              <div class="fr s-down-link" v-if="userInfo.code < 0" @click="downLoadVideo">
                <i class="wl-icon-xiazai"></i>下载视频
              </div>
              <a
                :href="downloadUrl"
                download="videoTitle"
                class="fr s-down-link"
                v-if="userInfo.code > 0"
              >
                <i class="wl-icon-xiazai"></i>下载视频
              </a>
            </div>
          </div>
          <p class="course-main-title">课程要义</p>
          <p class="course-main-val">{{videoContent}}</p>
          <p class="course-main-title">主讲嘉宾介绍</p>
          <div class="course-main-val clearfix">
            <div class="fl tea-cover-con">
              <img :src="teaUrl || avatar" alt />
            </div>
            <div class="fr tea-intro-con">
              <p>
                <span>{{teaName}}</span>
                <span class="tea-level-val">{{teaPost}}</span>
              </p>
              <p class="p-tea-intro-val">{{teaIntroduce}}</p>
            </div>
          </div>
        </div>
        <div class="fr v-more-list-con">
          <p class="h3-title-val">更多精彩视频</p>
          <ul>
            <li class="clearfix m-video-item" v-for="(item,index) in moreVideoList" :key="index">
              <router-link :to="{name:'videoDetail',params:{videoId:item.id}}">
                <div class="fl v-cover-con">
                  <img
                    :src="item.docUrl+'?x-oss-process=video/snapshot,t_10000,f_jpg,w_329,h_160' || cover"
                    alt
                  />
                  <div class="v-time-con">{{item.docTimeLenght}}</div>
                </div>
                <div class="fr v-intro-con">
                  <p class="p-v-name">{{item.videoTitle}}</p>
                  <p>
                    <i class="wl-icon-shijian">{{item.dateCreatedStr}}</i>
                  </p>
                  <p>
                    <i class="wl-icon-chakan"></i>
                    {{item.viewCount}}次观看
                  </p>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 登录弹框 -->
    <newLogin :isShow="showObject"></newLogin>
    <!-- 移动端 -->
    <div class="ph-video-detail-main">
      <div class="crumbs-text">
        <div style="padding:0 20px;">
          <i class="wl-icon-zhuye1"></i>
          <span @click="goHome" style="cursor: pointer;">首页</span>
          <span>></span>
          <span @click="toVideoList">串讲视频</span>
          <span>></span>
          <span class="v-name-val">{{videoTitle}}</span>
        </div>
      </div>
      <div class="ph-video-play-con">
        <video-player
          class="video-player-box"
          ref="videoPlayerPh"
          :options="phPlayerOptions"
          :playsinline="true"
          customEventName="customstatechangedeventname"
          @play="onPlayerPlayPh($event)"
          @pause="onPlayerPause($event)"
          @canplay="onPlayerCanplay($event)"
          @canplaythrough="onPlayerCanplaythrough($event)"
        ></video-player>
        <div class="clearfix ph-view-account">
          <span class="fl">
            <i class="wl-icon-chakan"></i>
            {{viewCount}}次观看
            <i class="wl-icon-shijian"></i>
            {{dateCreatedStr}}
          </span>
        </div>
      </div>
      <div class="course-main-info-con">
        <p class="p-label-title">课程要义</p>
        <div class="c-cours-info-val">{{videoContent}}</div>
      </div>
      <div class="course-main-info-con">
        <p class="p-label-title">主讲嘉宾介绍</p>
        <div class="clearfix p-tea-intro-con">
          <div class="fl ph-tea-avatar">
            <img :src="teaUrl || avatar" alt />
          </div>
          <div class="fl ph-tea-intro">
            <p>
              <span>{{teaName}}</span>
              <span class="tea-level-val">{{teaPost}}</span>
            </p>
            <p class="p-tea-intro-val">{{teaIntroduce}}</p>
          </div>
        </div>
      </div>
      <div class="course-main-info-con">
        <p class="p-label-title">更多精彩视频</p>
        <ul class="p-video-list-ul clearfix">
          <li class="fl p-video-item" v-for="(item,index) in moreVideoList" :key="index">
            <router-link :to="{name:'videoDetail',params:{videoId:item.id}}">
              <div class="cover-img-con">
                <img
                  :src="item.docUrl+'?x-oss-process=video/snapshot,t_10000,f_jpg,w_329,h_160' || cover"
                  alt
                />
                <div class="v-time-con">{{item.docTimeLenght}}</div>
              </div>
              <div class="p-video-detail-info">
                <p class="p-v-name">{{item.videoTitle}}</p>
                <p>
                  <i class="wl-icon-shijian"></i>
                  {{item.dateCreatedStr}}
                </p>
                <p>
                  <i class="wl-icon-chakan"></i>
                  {{item.viewCount}}次观看
                </p>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { MU_UPATE_AUTH, MU_UPATE_SCHOOL } from "store/index";
import newLogin from "components/videoLogin.vue";
export default {
  data() {
    return {
      playerOptions: {
        muted: true,
        language: "en",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        width: 858,
        height: 483,
        sources: [
          {
            type: "video/mp4",
            src:
              "https://file.clpp.org.cn/66ykt/ori/quioalgoh5bdatisgfv7sq/eW2mkd7cZhinBXFn.mp4"
          }
        ],
        poster: ""
      },
      phPlayerOptions: {
        muted: true,
        language: "en",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        width: "100%",
        height: 240,
        sources: [
          {
            type: "video/mp4",
            src: "https://file.clpp.org.cn/66ykt/ori/quioalgoh5bdatisgfv7sq/eW2mkd7cZhinBXFn.mp4"
          }
        ],
        poster: ""
      },
      cover:
        "https://file.clpp.org.cn/66ykt/ori/dd6xaesrd5lfbwst9cqswg/74dGZ3WTwcPWShai.png",
      avatar:
        "https://file.clpp.org.cn/66ykt/ori/dd6xaesrd5lfbwst9cqswg/x8WmGhQFHRDBWnbJ.png",
      downloadUrl: "",
      videoTitle: "",
      viewCount: 0,
      dateCreatedStr: "",
      teaUrl: "",
      videoContent: "",
      teaName: "",
      teaPost: "",
      teaIntroduce: "",
      moreVideoList: [],
      coverUrl: "",
      showObject: {
        isShow: false
      },
      shareLinkQq: "",
      shareLinkZone: "",
      shareCover: ""
    };
  },
  props: {
    videoId: {
      type: String,
      default: ""
    }
  },
  components: {
    newLogin
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
    userInfo() {
      return this.$store.state.auth;
    }
  },
  watch: {
    videoId(val) {
      this.getVideoDetail();
    }
  },
  created() {
    this.getVideoDetail();
  },
  methods: {
    toVideoList(){
      this.$router.push({
        name:'videoChart'
      });
    },
    goHome() {
      this.$router.push({
        name: "xHome"
      });
    },
    onPlayerCanplay(player) {},
    onPlayerCanplaythrough(player) {},
    toVideoDetail(id) {
      this.$router.push({
        name: "videoDetail",
        params: {
          videoId: id
        }
      });
    },
    getVideoDetail() {
      this.$http
        .post("/api/XOrg/VideoStudy/getTeaVideoInfo", {
          id: this.videoId
        })
        .then(res => {
          if (res.code > 0) {
            this.videoTitle = res.info.videoTitle;
            this.viewCount = res.info.viewCount;
            this.dateCreatedStr = res.info.dateCreatedStr;
            this.teaUrl = res.info.teaUrl;
            this.videoContent = res.info.videoContent;
            this.teaName = res.info.teaName;
            this.teaPost = res.info.teaPost;
            this.teaIntroduce = res.info.teaIntroduce;
            this.downloadUrl = res.downloadUrl;
            this.moreVideoList = res.moreVideoList;
            this.shareCover = `${res.info.docUrl}?x-oss-process=video/snapshot,t_10000,f_jpg,w_329,h_160`;
            this.$nextTick(() => {
              this.playerOptions.sources[0].src = '';
              this.phPlayerOptions.sources[0].src = '';
              this.playerOptions.sources[0].src = res.info.docUrl;
              this.phPlayerOptions.sources[0].src = res.info.docUrl;
              this.getShareLink();
            });
          }
        });
    },
    getShareLink() {
      let teaUrl = window.location.href;
      let teaShareLink = teaUrl;
      let newLink =
        "https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey" +
        "?url=" +
        teaShareLink +
        "&sharesource=qzone" +
        "&title=" +
        this.videoTitle +
        "&pics=" +
        this.shareCover +
        "&summary=" +
        this.videoContent;
      let shareLinkQq =
        "http://connect.qq.com/widget/shareqq/index.html" +
        "?url=" +
        teaShareLink +
        "&sharesource=qzone" +
        "&title=" +
        this.videoTitle +
        "&pics=" +
        this.shareCover +
        "&summary=" +
        this.videoContent;
      this.shareLinkZone = newLink;
      this.shareLinkQq = shareLinkQq;
    },
    onPlayerPlay(player) {
      // this.$refs.videoPlayer.player.pause();
      if (this.userInfo.code < 0) {
        this.$refs.videoPlayer.player.pause();
        this.showObject = {
          isShow: true
        };
        return false;
      }
    },
    onPlayerPlayPh(player) {
      if (this.userInfo.code < 0) {
        this.$message.warning("请先登录再观看！");
        this.$refs.videoPlayerPh.player.pause();
        return false;
      }
    },
    onPlayerPause(player) {},
    downLoadVideo() {
      this.showObject = {
        isShow: true
      };
    }
  }
};
</script>

<style lang="scss">
.wl-video-detail-wrapper {
  margin: 0 0 50px 0;
  .video-detail-main {
    margin: 0 auto;
    padding-top: 20px;
    width: 1200px;
  }
  .video-head-con {
    padding: 20px 0;
    .sp-label {
      margin-right: 10px;
    }
  }
  .v-detail-con {
    width: 858px;
  }
  .v-more-list-con {
    width: 321px;
  }
  .h3-title-val {
    border-bottom: 1px solid #dfe2e6;
    padding-bottom: 10px;
    font-size: 16px;
  }
  .m-video-item {
    margin-top: 15px;
    cursor: pointer;
  }
  .v-cover-con {
    position: relative;
    width: 137px;
    height: 77px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: fill;
    }
    .v-time-con {
      position: absolute;
      right: 4px;
      bottom: 6px;
      z-index: 100;
      background: rgba(0, 0, 0, 0.7);
      color: #fff;
      border-radius: 10px;
      padding: 5px;
      font-size: 12px;
    }
  }
  .v-intro-con {
    width: 175px;
    font-size: 14px;
    color: #505763;
    .p-v-name {
      color: #000;
      max-height: 38px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
  }
  .v-play-con {
    height: 483px;
    .video-player-box {
      .vjs-big-play-button {
        left: 50%;
        top: 50%;
        margin: -0.75em 0 0 -1.5em;
      }
    }
  }
  .v-intro-name {
    margin-top: 20px;
    color: #333333;
    font-size: 20px;
    line-height: 1.6;
  }
  .v-download-con {
    margin-top: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #dfe2e6;
    color: #505763;
    .wl-icon-dian1 {
      margin: 0 10px;
    }
    .share-icon-con {
      margin-left: 10px;
      width: 24px;
      height: 23px;
      border-radius: 50%;
      text-align: center;
      line-height: 23px;
      font-size: 14px;
    }
    .icon-con-1 {
      border: 1px solid #1ab2ff;
      color: #1ab2ff;
    }
    .icon-con-2 {
      border: 1px solid #f1ba14;
      color: #f1ba14;
    }
    .icon-con-3 {
      border: 1px solid #5ad23a;
      color: #5ad23a;
    }
    .sp-share-label {
      margin-top: 4px;
    }
    .s-down-link {
      margin: 4px 0 0 30px;
      color: #505763;
      cursor: pointer;
    }
  }
  .course-main-title {
    margin-top: 35px;
    color: #333333;
    padding-left: 10px;
    border-left: 3px solid #2d82ff;
    font-size: 18px;
    line-height: 1;
  }
  .course-main-val {
    margin-top: 19px;
    font-size: 16px;
    color: #333333;
    line-height: 1.4;
  }
  .tea-cover-con {
    width: 80px;
    height: 80px;
    overflow: hidden;
    border-radius: 50%;
    img {
      height: 100%;
      width: 100%;
      object-fit: fill;
    }
  }
  .tea-intro-con {
    width: 763px;
    color: #333333;
    font-size: 16px;
    .p-tea-intro-val {
      margin-top: 12px;
    }
    .tea-level-val {
      color: #999999;
      margin-left: 19px;
    }
  }
  .ph-video-detail-main {
    display: none;
    .crumbs-text {
      background: #f5f7fb;
      height: 40px;
      line-height: 40px;
      color: #666;
      span {
        margin: 0 3px;
      }
      .v-name-val {
        display: inline-block;
        width: calc(100% - 200px);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: top;
      }
    }
    .ph-video-play-con {
      padding: 10px;
      background: #fff;
      .video-js {
        width: 100%;
      }
      .vjs-big-play-button {
        left: 50%;
        top: 50%;
        margin: -0.75em 0 0 -1.5em;
      }
      .ph-view-account {
        padding: 5px 0;
        i {
          margin-right: 3px;
        }
      }
    }
    .p-label-title {
      padding-left: 10px;
      border-left: 2px solid #409eff;
      line-height: 1;
    }
    .course-main-info-con {
      margin-top: 10px;
      padding: 10px;
      background: #fff;
    }
    .c-cours-info-val {
      margin-top: 5px;
      line-height: 1.6;
    }
    .p-tea-intro-con {
      margin-top: 10px;
    }
    .ph-tea-avatar {
      margin-right: 10px;
      width: 60px;
      height: 60px;
      border-radius: 50%;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .ph-tea-intro {
      width: calc(100% - 90px);
      font-size: 12px;
      .p-tea-intro-val {
        margin-top: 5px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
      }
    }
    .p-video-list-ul {
      a {
        color: #333;
      }
      .p-video-item {
        margin: 10px 2% 0 0;
        width: 49%;
        a {
          display: block;
        }
      }
      .p-video-item:nth-child(2n) {
        margin-right: 0;
      }
      .cover-img-con {
        position: relative;
        height: 100px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .v-time-con {
          position: absolute;
          right: 4px;
          bottom: 6px;
          z-index: 100;
          background: rgba(0, 0, 0, 0.7);
          color: #fff;
          border-radius: 10px;
          padding: 5px;
          font-size: 12px;
        }
      }
      .p-video-detail-info {
        padding: 5px;
        font-size: 12px;
        background: #e9ecf0;
        .p-v-name {
          margin-bottom: 3px;
          overflow: hidden;
          white-space: nowrap;
        }
      }
    }
  }
}
@media only screen and (max-width:960px) {
  .wl-video-detail-wrapper {
    margin: 0;
    .video-detail-main {
      display: none;
    }
    .ph-video-detail-main {
      display: block;
    }
  }
}
</style>